// extracted by css-extract-rspack-plugin
export default {"container":"_64566c66","header":"_8afb985e"};